import React, { useEffect, useState, useMemo, useCallback } from "react";
import styled from "styled-components";
import {useManagePostRequest} from "../../../../../hooks/useManagePostRequest/useManagePostRequest";
import {
    cuadroRequerimientosAprobarCuadroSedeAPI,
    cuadroRequerimientosEliminarAsignacionAPI,
    cuadroRequerimientosEnviarCuadroSedeAPI,
    cuadroRequerimientosGetCuadroRequerimientosAPI,
    cuadroRequerimientosSepararBloquesCuadroRequerimientosAPI, cuadroRequerimientosUnirBloquesCuadroRequerimientosAPI,
} from "../../../../../consumers/backendApisUrls";
import {isNullOrUndefinded} from "../../../../../helper/utils";
import {useHistory} from "react-router-dom";
import {PrimaryActionButtonForPage} from "../../../styledComponents/styledComponents";
import ModalEnabled from "../../../../../components/modalComponents/ModalEnabled";
import CuadroRequerimientosAsignar from "./modales/CuadroRequerimientosAsignar";
import CuadroRequerimientosAsignacionTooltip from "./modales/CuadroRequerimientosAsignacionTooltip";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useDescargarArchivoDeS3} from "../../../../../hooks/useGenerarDescargarEliminarArchivo/useDescargarArchivoDeS3";
import MensajeConfirmacionDesasignarModal from "./modales/MensajeConfirmacionDesasignarModal";


const configuracionSeleccionAutomatica = {
    idsCursosQueNoSeSeleccionanAutomaticamenteParaGradosB_PK_K: [200024],
    idsCursosQueNoSeSeleccionanAutomaticamenteParaGrados1_2_3: [
        200024, 200027, 200028, 200034
    ]
};


const GRADOS_B_PK_K = ["B", "PK", "K"];
const GRADOS_1_2_3 = ["1", "2", "3"];
const GRADOS_MENORES_O_IGUAL_3 = ["B", "PK", "K", "1", "2", "3"];

const getGradoFromColumnKey = (colKey) => {
    const match = colKey.match(/^(PK|B|K|10|11|\d)/);
    return match ? match[0] : null;
};

const getAllHeaderColumnsGradoSecciones = groups =>
    groups.flatMap(g => g.GradoSecciones);

const esCeldaSoloVertical = (grado, idCurso) => {

    if (!GRADOS_MENORES_O_IGUAL_3.includes(grado)) return false;

    const esExcluido =
        (GRADOS_B_PK_K.includes(grado) &&
            configuracionSeleccionAutomatica
                .idsCursosQueNoSeSeleccionanAutomaticamenteParaGradosB_PK_K
                .includes(idCurso))
        ||
        (GRADOS_1_2_3.includes(grado) &&
            configuracionSeleccionAutomatica
                .idsCursosQueNoSeSeleccionanAutomaticamenteParaGrados1_2_3
                .includes(idCurso));

    return !esExcluido;
};

const getCellKey = (rowId, col) => `${rowId}-${col}`;


export default function CuadroDeRequerimientosTableView({ idCuadroSede }) {
    const [isLoading, setIsLoading] = useState(false);
    const [executeManagePost] = useManagePostRequest();
    const [tableData, setTableData] = useState();
    const history = useHistory();

    const [selectedCells, setSelectedCells] = useState(new Set());
    const [isMultiSelecting, setIsMultiSelecting] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [dragStartLocation, setDragStartLocation] = useState(null);
    const [seleccionEsGrupoCerrado, setSeleccionEsGrupoCerrado] = useState(false);
    const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});

    const [idAsignacion, setIdAsignacion] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState(null);

    const [descargarArchivoDeS3] = useDescargarArchivoDeS3();


    useEffect(() => {
        const init = async () => {
            const api = cuadroRequerimientosGetCuadroRequerimientosAPI();
            await executeManagePost(api, { IdCuadroSede: idCuadroSede }, ({data}) => {
                setTableData(data);
            });
        };
        init();
    }, []);


    useEffect(() => {

        if (!tableData || selectedCells.size === 0) {
            setIdAsignacion(null);
            return;
        }

        for (let key of selectedCells) {

            const [idCursoStr, colKey] = key.split("-");
            const idCurso = Number(idCursoStr);

            const row = rowsByIdCurso[idCurso];
            if (!row) continue;

            const cell = row.Cells[colKey];
            if (!cell) continue;

            if (cell.IdAsignacion != null) {
                setIdAsignacion(cell.IdAsignacion);
                return;
            }
        }

        setIdAsignacion(null);
        setTooltipPosition(null);

    }, [selectedCells, tableData]);


    useEffect(() => {
        const down = e => {
            if (e.ctrlKey || e.metaKey) setIsMultiSelecting(true);
            if (e.key === "Escape") setSelectedCells(new Set());
        };
        const up = e => {
            if (!e.ctrlKey && !e.metaKey) setIsMultiSelecting(false);
        };

        window.addEventListener("keydown", down);
        window.addEventListener("keyup", up);
        return () => {
            window.removeEventListener("keydown", down);
            window.removeEventListener("keyup", up);
        };
    }, []);

    useEffect(() => {
        const stop = () => setIsDragging(false);
        window.addEventListener("mouseup", stop);
        return () => window.removeEventListener("mouseup", stop);
    }, []);

    const rowsByIdCurso = useMemo(() => {

        if (!tableData) return {};

        const map = {};
        tableData.Rows.forEach(r => {
            map[r.IdCurso] = r;
        });

        return map;

    }, [tableData]);

    const getSelectedIdsCuadroBloque = useCallback(() => {

        if (!tableData || selectedCells.size === 0) return [];

        const ids = [];

        selectedCells.forEach(cellKey => {

            const [idCursoStr, colKey] = cellKey.split("-");
            const idCurso = Number(idCursoStr);

            const row = rowsByIdCurso[idCurso];
            if (!row) return;

            const cell = row.Cells[colKey];
            if (!cell) return;

            if (cell.IdCuadroBloque != null) {
                ids.push(cell.IdCuadroBloque);
            }

        });

        return ids;

    }, [selectedCells, rowsByIdCurso, tableData]);



    const AprobarCuadroSede = async () => {
        setIsLoading(true);
        const api = cuadroRequerimientosAprobarCuadroSedeAPI(idCuadroSede);
        const payload = {}
        await executeManagePost(api, payload, successAprobarCuadroSedeCallback, true , OnErrorAprobarCuadroSedeCallback, true);
        setIsLoading(false);
    }

    const successAprobarCuadroSedeCallback = async ({data}) => {
        await init();
    }

    const OnErrorAprobarCuadroSedeCallback = async ({data}) => {
        await init();
    }


    const EnviarCuadroSede = async () => {
        setIsLoading(true);
        const api = cuadroRequerimientosEnviarCuadroSedeAPI(idCuadroSede);
        const payload = {}
        await executeManagePost(api, payload, successEnviarCuadroSedeCallback, true , OnErrorEnviarCuadroSedeCallback, true);
        setIsLoading(false);
    }

    const successEnviarCuadroSedeCallback = async ({data}) => {
        await init();
    }

    const OnErrorEnviarCuadroSedeCallback = async ({data}) => {
        await init();
    }




    const allHeaderColumnsGradoSecciones = useMemo(
        () => getAllHeaderColumnsGradoSecciones(tableData?.HeaderColumnGroups ?? []),
        [tableData?.HeaderColumnGroups]
    );


    const getRangeSelectedCellKeys = useCallback((start, end) => {

        const keys = [];

        const startColKey = allHeaderColumnsGradoSecciones[start.colIndex];
        const startGrado = getGradoFromColumnKey(startColKey);
        const startEsGrupoCerrado = esCeldaSoloVertical(
            startGrado,
            tableData.Rows[start.rowIndex].IdCurso
        );

        for (let r = Math.min(start.rowIndex, end.rowIndex);
             r <= Math.max(start.rowIndex, end.rowIndex); r++) {

            const row = tableData.Rows[r];
            if (!row) continue;

            for (let c = Math.min(start.colIndex, end.colIndex);
                 c <= Math.max(start.colIndex, end.colIndex); c++) {

                const col = allHeaderColumnsGradoSecciones[c];
                const grado = getGradoFromColumnKey(col);

                const esGrupoCerradoActual = esCeldaSoloVertical(grado, row.IdCurso);

                if (!startEsGrupoCerrado && esGrupoCerradoActual) {
                    continue;
                }

                if (startEsGrupoCerrado) {
                    continue;
                }

                const cell = row.Cells[col];
                if (!cell || cell.Locked || cell.Hidden) continue;

                if (cell.IdAsignacion != null) continue;

                keys.push(getCellKey(row.IdCurso, col));
            }
        }

        return keys;

    }, [tableData, allHeaderColumnsGradoSecciones]);

    const UnirBloques = async () => {
        setIsLoading(true);
        const api = cuadroRequerimientosUnirBloquesCuadroRequerimientosAPI();
        const payload = {
            IdCuadroSede: idCuadroSede,
            SelectedCells: [...selectedCells]
        }
        await executeManagePost(api, payload, successUnirBloquesInitCallback);
        setIsLoading(false);
    }

    const init = async () => {
        const api = cuadroRequerimientosGetCuadroRequerimientosAPI();
        const payload = getPayload();
        await executeManagePost(api, payload, successInitCallback);
        setIsLoading(false);
    }


    const getPayload = () => {
        return {
            IdCuadroSede: idCuadroSede
        }
    }

    const successInitCallback = ({data}) => {
        setTableData(data);
        setIsLoading(false);
    }

    const successUnirBloquesInitCallback = async ({data}) => {
        await init();
        setSelectedCells(new Set())
        setIsLoading(false);
    }

    const DesasignarBloques = async (idAsignacion) => {
        const api = cuadroRequerimientosEliminarAsignacionAPI(idAsignacion);
        const payload = {
        }
        await executeManagePost(api, payload, successDesasignarBloquesInitCallback);
    }

    const successDesasignarBloquesInitCallback = async ({data}) => {
        await init();
        setSelectedCells(new Set())
    }

    const SepararBloques = async () => {
        setIsLoading(true);
        const api = cuadroRequerimientosSepararBloquesCuadroRequerimientosAPI();
        const payload = {
            IdCuadroSede: idCuadroSede,
            SelectedCells: [...selectedCells]
        }
        await executeManagePost(api, payload, successSepararBloquesInitCallback);
        setIsLoading(false);
    }


    const successSepararBloquesInitCallback = async ({data}) => {
        await init();
        setSelectedCells(new Set())
        setIsLoading(false);
    }

    const refreshTable = async () => {
        setIsLoading(true);
        await init();
        setSelectedCells(new Set())
        setIsLoading(false);
    }


    const getKeysByIdAsignacion = useCallback((idAsignacion) => {

        if (!tableData || idAsignacion == null) return [];

        const keys = [];

        tableData.Rows.forEach(r => {
            Object.entries(r.Cells).forEach(([colKey, cell]) => {
                if (!cell || cell.Hidden || cell.Locked) return;

                if (cell.IdAsignacion === idAsignacion) {
                    keys.push(getCellKey(r.IdCurso, colKey));
                }
            });
        });

        return keys;

    }, [tableData]);

    const descargarLog = async function (originalFileName, filePath) {
        await descargarArchivoDeS3(originalFileName, filePath);
    }

    if (isNullOrUndefinded(tableData)) return null;

    return (
        <>
            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
                refreshPage={refreshTable}
            />
            <div className="d-flex justify-content-end">
                <PrimaryActionButtonForPage
                    onClick={() => history.push("/cuadroRequerimientosListar")}
                >
                    Atrás
                </PrimaryActionButtonForPage>
            </div>
            <div style={{ overflowX: "auto" }}>

                <table style={styles.table}>
                    <thead>
                    <tr>
                        <th rowSpan={2} style={{...styles.headerSticky,...styles.firstColumn}}>Curso</th>
                        {tableData?.HeaderColumnGroups?.map(g => (
                            <th key={g.Nivel} colSpan={g.GradoSecciones.length} style={styles.groupHeader}>
                                {g.Nivel}
                            </th>
                        ))}
                        <th rowSpan={2} style={styles.headerSticky}>Total</th>
                    </tr>
                    <tr>
                        {allHeaderColumnsGradoSecciones.map(c => (
                            <th key={c} style={styles.subHeader}>{c}</th>
                        ))}
                    </tr>
                    </thead>

                    <tbody>
                    {tableData.Rows.map((row, rowIndex) => {

                        let cursor = 0;
                        const rowCells = [];

                        while (cursor < allHeaderColumnsGradoSecciones.length) {

                            const colKey = allHeaderColumnsGradoSecciones[cursor];
                            const cell = row.Cells[colKey];

                            if (!cell || cell.Hidden) {
                                cursor++;
                                continue;
                            }

                            const span = cell.ColSpan > 0 ? cell.ColSpan : 1;
                            const visualColIndex = cursor;
                            const cellKey = getCellKey(row.IdCurso, colKey);
                            const isSelected = selectedCells.has(cellKey);
                            const grado = getGradoFromColumnKey(colKey);

                            rowCells.push(
                                <td
                                    key={cellKey}
                                    colSpan={span}
                                    onMouseDown={(e) => {

                                        e.preventDefault();
                                        if (cell.Locked) return;

                                        const idCurso = row.IdCurso;
                                        const soloVertical = esCeldaSoloVertical(grado, idCurso);

                                        if (cell.IdAsignacion != null) {
                                            const keys = getKeysByIdAsignacion(cell.IdAsignacion);
                                            setSelectedCells(new Set(keys));
                                            setSeleccionEsGrupoCerrado(true);
                                            setIsDragging(false);

                                            const tooltipWidth = 320;
                                            const tooltipHeight = 220;
                                            const safeMargin = 25;

                                            let x = e.clientX + 15;
                                            let y = e.clientY + 15;

                                            const viewportWidth = window.innerWidth;
                                            const viewportHeight = window.innerHeight;

                                            if (x + tooltipWidth > viewportWidth - safeMargin) {
                                                x = e.clientX - tooltipWidth - 15;
                                            }

                                            if (y + tooltipHeight > viewportHeight - safeMargin) {
                                                y = e.clientY - tooltipHeight - 15;
                                            }

                                            if (y < safeMargin) y = safeMargin;
                                            if (x < safeMargin) x = safeMargin;

                                            setTooltipPosition({ x, y });
                                            return;
                                        }


                                        if (soloVertical) {

                                            const keys = [];

                                            tableData.Rows.forEach(r => {

                                                if (!esCeldaSoloVertical(grado, r.IdCurso)) return;

                                                const c = r.Cells[colKey];
                                                if (!c || c.Locked || c.Hidden) return;

                                                keys.push(getCellKey(r.IdCurso, colKey));
                                            });

                                            setSelectedCells(new Set(keys));
                                            setSeleccionEsGrupoCerrado(true);
                                            setIsDragging(false);
                                            return;
                                        }


                                        if (isMultiSelecting) {
                                            if (seleccionEsGrupoCerrado) return;

                                            if (cell.IdAsignacion != null) return;

                                            if (soloVertical) return;

                                            setSelectedCells(prev => {
                                                const next = new Set(prev);
                                                next.has(cellKey)
                                                    ? next.delete(cellKey)
                                                    : next.add(cellKey);
                                                return next;
                                            });

                                            return;
                                        }



                                        setSeleccionEsGrupoCerrado(false);
                                        setDragStartLocation({rowIndex, colIndex: visualColIndex});
                                        setIsDragging(true);

                                        setSelectedCells(new Set([cellKey]));
                                        setTooltipPosition(null);
                                    }}
                                    onMouseEnter={() => {

                                        if (!isDragging || !dragStartLocation) return;

                                        if (seleccionEsGrupoCerrado) return;

                                        setSelectedCells(new Set(
                                            getRangeSelectedCellKeys(
                                                dragStartLocation,
                                                {rowIndex, colIndex: visualColIndex}
                                            )
                                        ));
                                    }}
                                    style={{
                                        ...styles.cell,
                                        background: cell.Locked ? "#e0e0e0" : (cell.Color || "#fff"),
                                        outline: isSelected ? "2px solid #1976d2" : "none",
                                        outlineOffset: "-2px"
                                    }}
                                >
                                    {cell.Value ?? ""}
                                </td>
                            );

                            cursor += span;
                        }

                        return (
                            <tr key={row.IdCurso}>
                                <td style={{...styles.courseCell,...styles.firstColumn}}>
                                    {row.Curso}
                                </td>
                                {rowCells}
                                <td style={styles.totalCell}>{row.TotalBloques}</td>
                            </tr>
                        );
                    })}
                    <tr>
                        <td
                            colSpan={allHeaderColumnsGradoSecciones.length + 1}
                            style={{
                                ...styles.courseCell,
                                textAlign: "right"
                            }}
                        >
                            Total de bloques:
                        </td>
                        <td style={styles.totalCell}>
                            {tableData?.TotalBloques ?? 0}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <Actions>
                { !isNullOrUndefinded(idAsignacion) && tableData?.PuedeEditarAsignacion &&
                    <>
                        <ActionGroup>
                            <GhostButton  onClick={(e) =>
                            {
                                if (e) e.preventDefault();
                                setTooltipPosition(null);
                                setModalEnabled({
                                    isEnable: true,
                                    component: CuadroRequerimientosAsignar,
                                    data: {idCuadroSede: idCuadroSede, idsCuadroBloque: [], idAsignacionProp: idAsignacion, isFromEditar: true}
                                })
                            }
                            }
                            >Editar
                            </GhostButton>
                        </ActionGroup>
                        <ActionDivider />
                    </>
                }

                <ActionGroup>
                    {!isNullOrUndefinded(idAsignacion) && tableData?.PuedeDesasignar &&
                        <GhostButton  onClick={(e) =>
                        {
                            if (e) e.preventDefault();
                            setTooltipPosition(null);
                            setModalEnabled({
                            isEnable: true,
                            component: MensajeConfirmacionDesasignarModal,
                            data: {idAsignacion: idAsignacion, DesasignarBloques:DesasignarBloques}
                        })
                        }
                        }
                    >Desasignar
                    </GhostButton>
                    }

                    {isNullOrUndefinded(idAsignacion) &&  tableData?.PuedeAsignar &&
                        <GhostButton  disabled={isLoading} onClick={(e) =>
                        {
                            if (e) e.preventDefault();
                            const idsCuadroBloque = getSelectedIdsCuadroBloque();

                            setModalEnabled({
                                isEnable: true,
                                component: CuadroRequerimientosAsignar,
                                data: {idCuadroSede: idCuadroSede, idsCuadroBloque: idsCuadroBloque, isFromEditar: false}
                            })
                        }
                        }
                        >Asignar
                        </GhostButton>
                    }

                </ActionGroup>

                {isNullOrUndefinded(idAsignacion) &&
                <>
                    <ActionDivider />

                    <ActionGroup>

                        {tableData?.PuedeUnirBloques === true &&
                            <GhostButton onClick={UnirBloques} disabled={isLoading}>Unir bloques</GhostButton>
                        }

                        {tableData?.PuedeSepararBloques === true &&
                            <GhostButton onClick={SepararBloques} disabled={isLoading}>Separar bloques</GhostButton>
                        }
                    </ActionGroup>
                </>
                }



                <ActionDivider />

                {tableData?.PuedeEnviar &&
                    <ActionGroup>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <PositiveButton
                                onClick={EnviarCuadroSede}
                                isLoading={isLoading}
                            >
                                Enviar
                                {isLoading && (
                                    <FontAwesomeIcon
                                        icon="spinner"
                                        spin
                                        className="ms-2"
                                    />
                                )}
                            </PositiveButton>

                            {tableData?.CREnviarCuadroSedeLog && !isLoading && (
                                <GhostButton onClick={() => descargarLog(tableData?.CREnviarCuadroSedeLog?.OriginalFileName, tableData?.CREnviarCuadroSedeLog?.Path)}>Ver errores de envío</GhostButton>
                            )}
                        </div>
                    </ActionGroup>
                }

                {tableData?.PuedeAprobar &&
                    <ActionGroup>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <PositiveButton
                                onClick={AprobarCuadroSede}
                                isLoading={isLoading}
                            >
                                Aprobar
                                {isLoading && (
                                    <FontAwesomeIcon
                                        icon="spinner"
                                        spin
                                        className="ms-2"
                                    />
                                )}
                            </PositiveButton>
                        </div>
                    </ActionGroup>
                }

            </Actions>

            { !isNullOrUndefinded(tooltipPosition)
                &&
                <CuadroRequerimientosAsignacionTooltip
                    idAsignacion={idAsignacion}
                    position={tooltipPosition}
                    onClose={() => {
                        setTooltipPosition(null);
                    }}
                />
            }



        </>



    );
}


export const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center; 
  gap: 12px;
  margin: 32px 0;
`;

export const ActionGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const ActionDivider = styled.div`
  width: 1px;
  height: 32px;
  background: #d1d5db;
  margin: 0 20px;
`;

export const Button = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: all 0.15s ease;

    &:disabled {
        background: #e5e7eb;
        color: #9ca3af;
        cursor: not-allowed;
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: none;
    }
`;


export const PositiveButton = ({ children, isLoading, ...props }) => {
    return (
        <StyledPositiveButton {...props} disabled={isLoading || props.disabled}>
            {children}
        </StyledPositiveButton>
    );
};


const StyledPositiveButton = styled(Button)`
    background: #16a34a;
    color: white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    line-height: 1;
    padding: 0.5rem 1rem;
    border: none; 

    &:hover:not(:disabled) {
        background: #15803d;
    }

    &:disabled {
        cursor: not-allowed;
        pointer-events: none;

        background: #9ca3af; 
        color: #f3f4f6;      
        opacity: 1;          
    }

    svg {
        display: block;
        margin: 0;
    }
`;



export const UndoButton = styled(Button)`
  background: white;
  color: #374151;
  border: 1px solid #d1d5db;

  &:hover:not(:disabled) {
    background: #f3f4f6;
  }
`;

export const PrimaryButton = styled(Button)`
  background: #111827;
  color: white;
  padding: 10px 20px;

  &:hover:not(:disabled) {
    background: #020617;
  }
`;

export const SecondaryButton = styled(Button)`
  background: #374151;
  color: white;

  &:hover:not(:disabled) {
    background: #1f2937;
  }
`;

export const GhostButton = styled(Button)`
  background: transparent;
  color: #374151;
  border: 1px solid #d1d5db;

  &:hover:not(:disabled) {
    background: #f3f4f6;
  }
`;

export const DangerButton = styled(Button)`
  background: transparent;
  color: #dc2626;
  border: 1px solid #fca5a5;

  &:hover:not(:disabled) {
    background: #fee2e2;
  }
`;

export const SuccessButton = styled(Button)`
  background: #22c55e;
  color: white;
  padding: 10px 20px;

  &:hover:not(:disabled) {
    background: #16a34a;
  }
`;

const baseBorder = "1px solid #ccc";

const styles = {
    firstColumn: {
        position: "sticky",
        left: 0,
        zIndex: 3,
        width: 180,
        minWidth: 180,
        maxWidth: 180,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    table: {
        borderCollapse: "separate",
        borderSpacing: 0,
        width: "max-content",
        minWidth: "auto",
        tableLayout: "fixed"
    },
    groupHeader: {
        background: "#e5e7eb",
        padding: 8,
        border: baseBorder
    },
    subHeader: {
        background: "#f5f5f5",
        padding: 6,
        border: baseBorder,
        width: 40,
        minWidth: 40,
        maxWidth: 40
    },
    headerSticky: {
        background: "#e5e7eb",
        padding: 8,
        border: baseBorder,
        position: "sticky",
        left: 0,
        zIndex: 4
    },
    courseCell: {
        background: "#f5f5f5",
        padding: 6,
        fontWeight: "bold",
        border: baseBorder,
        textAlign: "left"
    },
    cell: {
        border: baseBorder,
        padding: 6,
        width: 40,
        minWidth: 40,
        maxWidth: 40,         
        textAlign: "center"
    },
    totalCell: {
        background: "#fafafa",
        fontWeight: "bold",
        textAlign: "center",
        border: baseBorder,
        width: 60,
        minWidth: 60,
        maxWidth: 60
    }
};